var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.54 44.553 v 10.459 h -3.374 V 29.145 h 8.772 c 2.137 0 4.161 0.787 5.736 2.249 c 1.575 1.35 2.362 3.374 2.362 5.511 s -0.787 4.049 -2.362 5.511 c -1.575 1.462 -3.486 2.249 -5.736 2.249 L 42.54 44.553 L 42.54 44.553 z M 42.54 32.294 v 8.997 h 5.623 c 1.237 0 2.474 -0.45 3.261 -1.35 c 1.799 -1.687 1.799 -4.499 0.112 -6.186 l -0.112 -0.112 c -0.9 -0.9 -2.024 -1.462 -3.261 -1.35 L 42.54 32.294 L 42.54 32.294 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(95,99,104)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 63.796 36.793 c 2.474 0 4.386 0.675 5.848 2.024 c 1.462 1.35 2.137 3.149 2.137 5.398 v 10.797 h -3.149 v -2.474 h -0.112 c -1.35 2.024 -3.261 3.037 -5.511 3.037 c -1.912 0 -3.599 -0.562 -4.948 -1.687 c -1.237 -1.125 -2.024 -2.699 -2.024 -4.386 c 0 -1.799 0.675 -3.261 2.024 -4.386 c 1.35 -1.125 3.261 -1.575 5.511 -1.575 c 2.024 0 3.599 0.337 4.836 1.125 v -0.787 c 0 -1.125 -0.45 -2.249 -1.35 -2.924 c -0.9 -0.787 -2.024 -1.237 -3.261 -1.237 c -1.912 0 -3.374 0.787 -4.386 2.362 l -2.924 -1.799 C 58.285 37.918 60.647 36.793 63.796 36.793 z M 59.522 49.614 c 0 0.9 0.45 1.687 1.125 2.137 c 0.787 0.562 1.687 0.9 2.587 0.9 c 1.35 0 2.699 -0.562 3.711 -1.575 c 1.125 -1.012 1.687 -2.249 1.687 -3.599 c -1.012 -0.787 -2.474 -1.237 -4.386 -1.237 c -1.35 0 -2.474 0.337 -3.374 1.012 C 59.972 47.815 59.522 48.602 59.522 49.614 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(95,99,104)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 37.355 l -11.134 25.53 h -3.374 L 79.653 54 l -7.31 -16.532 h 3.599 l 5.286 12.709 h 0.112 l 5.173 -12.709 H 90 V 37.355 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(95,99,104)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.157 42.304 c 0 -1.012 -0.112 -2.024 -0.225 -3.037 H 14.873 v 5.736 h 7.985 c -0.337 1.799 -1.35 3.486 -2.924 4.499 v 3.711 h 4.836 C 27.582 50.626 29.157 46.802 29.157 42.304 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(66,133,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.873 56.812 c 4.049 0 7.423 -1.35 9.897 -3.599 l -4.836 -3.711 c -1.35 0.9 -3.037 1.462 -5.061 1.462 c -3.824 0 -7.198 -2.587 -8.322 -6.186 H 1.603 v 3.824 C 4.189 53.663 9.25 56.812 14.873 56.812 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(52,168,83)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.551 44.778 c -0.675 -1.799 -0.675 -3.824 0 -5.736 v -3.824 H 1.603 c -2.137 4.161 -2.137 9.11 0 13.383 L 6.551 44.778 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(251,188,4)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.873 32.969 c 2.137 0 4.161 0.787 5.736 2.249 l 0 0 l 4.274 -4.274 c -2.699 -2.474 -6.298 -3.936 -9.897 -3.824 c -5.623 0 -10.797 3.149 -13.271 8.21 l 4.948 3.824 C 7.676 35.556 11.05 32.969 14.873 32.969 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(234,67,53)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayLogo);
export default __webpack_public_path__ + "static/media/google-pay-logo.6908923c247b190a3042ff8a587dde50.svg";
export { ForwardRef as ReactComponent };